import { MalayTranslationEnum } from "./app-constant/MalayTranslation";
import { EnglishTranslationEnum } from "./app-constant/EnglishTranslation";
import { ExternalLinksEnum } from "./app-constant/ExternalLinks";
import { ProductCodeEnum } from "./app-constant/ProductCode"

export const MalayTranslation = MalayTranslationEnum;
export const EnglishTranslation = EnglishTranslationEnum;
export const ExternalLinks = ExternalLinksEnum;
export const ProductCode = ProductCodeEnum;

export const DirectorConstants = {
    SOLEPROPRIETOR: 'B',
    // changed according to ctos ssm implementation
    PARTNERSHIP: 'B',
    SDNBHD: 'C',
    // PARTNERSHIP: 'C',
    // SDNBHD: 'D',
    MALAYSIA: 'MY',
    SINGAPORE: 'SG'
  }

export const TransactionConstants = {
    AccountOthersValue: 'OTH',
    BusinessInvestment: 'BI',
    IncomeFromEmployment: 'IE',
    ProceedsFromBusiness: 'PI',
    IncomeFromOtherSources: 'OTH',
    TaxInfoMalaysia: 'MY',
    TaxInfoUSA: 'US',
    TaxInfoOthers: 'OTH'
}

export const FlowId = {
    FirstDirectorFlow: '1',
    SecondDirectorFlow: '2'
}
